import { ProjectCodesService } from './ProjectCodesService';

function getHTMLLabelForTekPoint(point: any): string | undefined {
    if (point.isLinePoint) return;

    const content: string[] = [];
    const props = point.props || {};
    const numericData: { key: number; value: string | number }[] = [];
    const depthEntries: { key: number; value: string; depth: string }[] = [];
    const al = props.alkukairaustiedot ? 'AL ' + props.alkukairaustiedot : '';
    const hm = props.huomautustekstit ? 'HM ' + props.huomautustekstit : '';
    const tx = props['vapaat tekstit'] ? 'TX ' + props['vapaat tekstit'] : '';
    let at = '';
    let ps = '';
    let pvm = '';
    let tt = '';
    let om = '';
    let pt = '';
    let to = '';

    for (const [key, value] of Object.entries(props)) {
        if (!isNaN(Number(key))) {
            if (typeof value === 'string') {
                // Add all entries with numeric keys to numericData
                numericData.push({ key: Number(key), value });

                // Check if the line starts with a number (depth entry)
                const firstPart = value.trim().split(/\s+/)[0];
                if (!isNaN(Number(firstPart))) {
                    // This is a depth entry line
                    const parts = value.trim().split(/\s+/);
                    if (parts.length >= 2) {
                        depthEntries.push({
                            key: Number(key),
                            value: value,
                            depth: firstPart,
                        });
                    }
                }
            }
        } else if (typeof value === 'string') {
            switch (key) {
                case 'XY': {
                    const parts = value.split(/\s+/);
                    if (parts.length >= 4) {
                        at = parts[2];
                        const rawDate = parts[3];

                        try {
                            const day = rawDate.substring(0, 2);
                            const month = rawDate.substring(2, 4);
                            const year = rawDate.substring(4, 8);
                            const date = new Date(Number(year), Number(month) - 1, Number(day));

                            // Check if the date is valid
                            if (isNaN(date.getTime())) {
                                pvm = '000000';
                            } else {
                                pvm = date.toLocaleDateString('fi-FI');
                            }
                        } catch (error) {
                            pvm = '000000';
                        }
                    }
                    break;
                }
                case 'tutkimustapa':
                    tt = value.split(/\s+/)[0];
                    break;
                case 'tiedon omistaja':
                    om = value;
                    break;
                case 'päättymistapa':
                    pt = value;
                    break;
                case 'tutkimusorganisaatio':
                    to = value;
                    break;
            }
        }
    }
    console.log(depthEntries);
    numericData.sort((a, b) => a.key - b.key);
    depthEntries.sort((a, b) => a.key - b.key);
    if (depthEntries.length > 0) {
        const lastDepthEntry = depthEntries[depthEntries.length - 1];
        if (tt === 'NO' || tt === 'NE') {
            console.log(lastDepthEntry);
            const depth1 = Number(lastDepthEntry.depth.split(/\s+/)[0]);
            const depth2 = Number(lastDepthEntry.value.split(/\s+/)[2]);
            const finalDepth = (depth1 + depth2) / 2;
            ps = (parseInt(at) - finalDepth).toFixed(2);
        } else if (tt === 'KE') {
            const depth1 = Number(lastDepthEntry.depth);
            const depth2 = Number(lastDepthEntry.value.split(/\s+/)[1]);
            const finalDepth = (depth1 + depth2) / 2;
            ps = (parseInt(at) - finalDepth).toFixed(2);
        } else {
            ps = (parseFloat(at) - parseFloat(lastDepthEntry.depth)).toFixed(2);
        }
    }

    content.push(`<div class='json-pairs'>`);

    const addRow = (label: string, value: string) => {
        content.push(`<div style="white-space: nowrap">`);
        content.push(label + ': ');
        content.push(value);
        content.push(`</div>`);
    };

    if (tt) addRow('Tutkimustapa', tt);
    if (om) addRow('Omistaja', om);
    if (pvm) addRow('Päiväys', pvm);
    if (at) addRow('Aloitustaso', at);
    if (ps) addRow('Päättymissyvyys', ps);
    if (pt) addRow('Päättymistapa', pt);
    if (to) addRow('Tutkimusorganisaatio', to);

    if (numericData.length > 0) {
        content.push(`<div style="white-space: nowrap">Data:</div>`);
        if (tx !== '') {
            const txContent = tx.substring(3);
            content.push(`<div style="white-space: pre-wrap; text-indent: -20px; padding-left: 20px; padding-right: 20px;">&nbsp;&nbsp;&nbsp;&nbsp;TX ${txContent}</div>`);
        }
        if (hm !== '') {
            const hmContent = hm.substring(3);
            content.push(`<div style="white-space: pre-wrap; text-indent: -20px; padding-left: 20px; padding-right: 20px;">&nbsp;&nbsp;&nbsp;&nbsp;HM ${hmContent}</div>`);
        }
        if (al !== '') {
            content.push(`<div style="white-space: nowrap">&nbsp;&nbsp;&nbsp;&nbsp;${al}</div>`);
        }
        numericData.forEach(item => {
            content.push(`<div style="white-space: nowrap">&nbsp;&nbsp;&nbsp;&nbsp;${item.value}</div>`);
        });
    }

    content.push('</div>');
    return content.join('');
}

function getHTMLLabelForOutlinePoint(point: IOutlinePoint) {
    if (point.isLinePoint) return;

    const content = [];

    content.push("<div class='json-pairs'>");
    content.push('<div style="white-space: nowrap">');
    content.push(kuura.getMessage('tablet.filename_js'));
    content.push(': ');
    content.push(point.filename);
    content.push('</div>');

    if (point.pointNumber) {
        content.push('<div>');
        content.push(kuura.getMessage('tablet.number_js'));
        content.push(': ');
        content.push(point.pointNumber);
        content.push('</div>');
    }

    if (point.pointName) {
        content.push('<div>');
        content.push(kuura.getMessage('tablet.name_js'));
        content.push(': ');
        content.push(point.pointName);
        content.push('</div>');
    }

    if (point.code) {
        content.push('<div>');
        content.push(kuura.getMessage('tablet.code_js'));
        content.push(': ');
        content.push(ProjectCodesService.codeWithDescription(point.code));
        content.push('</div>');
    }

    if (point.surfaceCode) {
        content.push('<div>');
        content.push(kuura.getMessage('js_logpoints.column_surfacecode'));
        content.push(': ');
        content.push(point.surfaceCode);
        content.push('</div>');
    }
    Object.entries(point.props).forEach(([key, val]) => {
        content.push('<div>');
        if (key === 'pointName') {
            content.push(kuura.getMessage('js_logpoints.column_point_name'));
        } else {
            content.push(key);
        }

        content.push(': ');
        if (String(val).startsWith('http://') || String(val).startsWith('https://')) {
            content.push(`<a href="${val}" target="_blank" rel="noopener" title="Hold shift or alt or ctrl to open in floating window">${val}</a>`);
        } else {
            content.push(val);
        }
        content.push('</div>');
    });

    content.push('<div>x: ' + point.northing + '</div>');
    content.push('<div>y: ' + point.easting + '</div>');
    content.push('<div>z: ' + point.elevation + '</div>');

    content.push("<div id='code-description-wrapper'></div>");
    content.push('</div>');

    content.push("<div id='gt-point-link-wrapper'></div>");

    return content.join('');
}

function getHTMLLabelForProperties(props: object): string {
    const content = [];

    Object.entries(props).forEach(([key, val]) => {
        content.push('<div>');
        if (key === 'pointName') {
            content.push(kuura.getMessage('js_logpoints.column_point_name'));
        } else {
            content.push(key);
        }

        content.push(': ');
        if (String(val).startsWith('http://') || String(val).startsWith('https://')) {
            content.push(`<a href="${val}" target="_blank" rel="noopener" title="Hold shift or alt or ctrl to open in floating window">${val}</a>`);
        } else {
            content.push(val);
        }
        content.push('</div>');
    });

    return content.join('');
}

export const LabelService = {
    getHTMLLabelForOutlinePoint,
    getHTMLLabelForTekPoint,
    getHTMLLabelForProperties,
};
